import axios from '../utils/axios';
import {
  ADD_CONTACT,
  GET_CONTACT,
  CONTACT_FAIL,
  GET_CONTACTS,
  DELETE_CONTACT
} from './types';

export const newContact = (formData, history) => async dispatch => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };
    const res = await axios.post('/api/contact', formData, config);
    dispatch({
      type: ADD_CONTACT,
      payload: res.data
    });
    history.push(`/show_contact/${res.data._id}`);
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach(error => console.log(error.msg));
    }
    dispatch({
      type: CONTACT_FAIL
    });
  }
};

export const getContactById = id => async dispatch => {
  try {
    const res = await axios.get(`/api/contact/contactID/${id}`);
    dispatch({
      type: GET_CONTACT,
      payload: res.data
    });
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach(error => console.log(error.msg));
    }
  }
};

export const getMyContacts = () => async dispatch => {
  try {
    const res = await axios.get('/api/contact/myAllContacts');
    dispatch({
      type: GET_CONTACTS,
      payload: res.data
    });
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach(error => console.log(error.msg));
    }
  }
};

export const editContact = (formData, id, history) => async dispatch => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };
    const res = await axios.post(`/api/contact/edit/${id}`, formData, config);
    dispatch({
      type: ADD_CONTACT,
      payload: res.data
    });
    history.push(`/show_contact/${res.data._id}`);
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach(error => console.log(error.msg));
    }
    dispatch({
      type: CONTACT_FAIL
    });
  }
};

export const deleteContact = (id, history) => async dispatch => {
  try {
    const res = await axios.get(`/api/contact/delete/${id}`);
    await dispatch({
      type: DELETE_CONTACT,
      payload: res.data
    });
    await dispatch(getMyContacts());
    history.push('/contacts');
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach(error => console.log(error.msg));
    }
  }
};

export const editBackground = (formData, id) => async dispatch => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };
    const res = await axios.post(
      `/api/contact/editBackground/${id}`,
      formData,
      config
    );
    dispatch({
      type: GET_CONTACT,
      payload: res.data
    });
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach(error => console.log(error.msg));
    }
  }
};



// WEBPACK FOOTER //
// ./src/actions/contact.js